/* esm.sh - applesauce-common@5.2.0/dist/helpers/stream */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/stream.mjs";
